<div class="app-shell">

  <!-- ── Left: fixed-width side navigation ─────────────────────────────── -->
  <aside class="app-shell__sidebar">
    <app-sidebar />
  </aside>

  <!-- ── Right: vertical flex column (header + scrollable content) ──────── -->
  <div class="app-shell__main">

    <!-- Global header — 48px fixed height -->
    <div class="app-shell__header">
      <app-header />
    </div>

    <!-- Scrollable content area wrapping router-outlet -->
    <main class="app-shell__content" id="main-content" tabindex="-1">
      <router-outlet />
    </main>

  </div>
</div>